import React from "react"
import { Box } from "@mui/material"

import AnalyzersFeaturesSelector from "Pages/AnalyzersV2/@components/Table/Toolbar/FeaturesSelector"
import AnalyzerTableActions from "Pages/AnalyzersV2/@components/Table/Toolbar/Actions"
import ToggleTableDetails from "./ToggleDetails";
import { AppCardTitle } from "@components"


export default function AnalyzerTableToolbar({ isRating = false, isPosition = false }) {

	return <Box sx={{ display: "flex", alignItems: "center", flexWrap: "wrap", gap: 2, width: "100%", mb: 1.5 }}>
		<AppCardTitle icon="table-cells" title="Analyzer: Price Table"/>
		<Box sx={{ display: "flex", alignItems: "center", justifyContent: "flex-end", flexWrap: "wrap", gap: 2, ml: "auto" }}>
			{/* Position pins its cell to price + gap, so neither the details toggle
			    nor the feature picker would change anything on screen. */}
			{!isPosition && <ToggleTableDetails />}
			{!isRating && !isPosition && <AnalyzersFeaturesSelector/>}
			{/* The Min/Max switch is hidden for position: that analyzer only ever
			    works on min_price, so the Max tab would have no data behind it. */}
			{!isRating && !isPosition && <AnalyzerTableActions />}
		</Box>
	</Box>
}
